import "./Aboutme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import { faGamepad } from "@fortawesome/free-solid-svg-icons";
import { faMotorcycle } from "@fortawesome/free-solid-svg-icons";
import { faBowlFood } from "@fortawesome/free-solid-svg-icons";

export const Aboutme = () => {
  return (
    <>
      <div className="pt-1 pb-5 xs:px-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mt-10">
            <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                    <FontAwesomeIcon className="text-4xl" icon={faMusic} />
                  </div>
                  <p className="font-heading ml-16 text-lg leading-6 font-bold text-white">
                    Music Enthusiast
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-300 xs:text-justify">
                  Music is the rhythm of my life. My fingers find solace on the
                  fretboard of a guitar. Playing the guitar is not just a hobby;
                  it's my way of expressing emotions and connecting with the
                  world. The ability to create beautiful harmonies through six
                  strings is a gift I cherish.
                </dd>
              </div>
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                    <FontAwesomeIcon className="text-4xl" icon={faGamepad} />
                  </div>
                  <p className="font-heading ml-16 text-lg leading-6 font-bold text-white">
                    Mobile Gamer
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-300 xs:text-justify">
                  {" "}
                  In the virtual realm, I'm a skilled mobile gamer. Whether it's
                  conquering kingdoms, solving puzzles, or competing in intense
                  battles, I find the world of mobile gaming to be an exciting
                  escape.
                </dd>
              </div>
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                    <FontAwesomeIcon className="text-4xl" icon={faMotorcycle} />
                  </div>
                  <p className="font-heading ml-16 text-lg leading-6 font-bold text-white">
                    Motorcycle Adventurer
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-300 xs:text-justify">
                  When I'm not lost in the world of music or gaming, you'll
                  often catch me hitting the open road on my trusty motorcycle.
                  The freedom of the open highway and the thrill of the wind in
                  my hair are experiences I treasure.
                </dd>
              </div>
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                    <FontAwesomeIcon className="text-4xl" icon={faBowlFood} />
                  </div>
                  <p className="font-heading ml-16 text-lg leading-6 font-bold text-white">
                    Food Explorer
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-300 xs:text-justify">
                  Food isn't just sustenance; it's an adventure. I'm a
                  passionate foodie, always on the lookout for new culinary
                  delights. From street food stalls to fine dining restaurants,
                  I love to explore different flavors and cuisines.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <div className="xs:text-justify pb-10 xs:px-4">
          <p className="mt-4 max-w-7xl text-base text-gray-300 lg:mx-auto xs:indent-10">
            In summary, I'm a music-loving, guitar-strumming, motorcycle-riding,
            mobile gaming, and food-tripping enthusiast with a strong foundation
            in Visual Basic.Net and with Web Development. Life is all about balance, and I aim
            to strike the perfect harmony between my passions and my technical
            skills, creating a life that's as dynamic as it is enjoyable.
          </p>
        </div>
    </>
  );
};
